<script lang="ts" setup>
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.esm.js";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "@twiage/view/styles.css";

import * as core from "@twiage/core";
import * as utils from "@twiage/utils";

import { navigateTo, useHead, useRuntimeConfig } from "#app";

const runtimeConfig = useRuntimeConfig();
const { apiURL } = core.loadEnvironmentVariables({
  runtimeConfig,
});

core.initHTTP({ prefixURL: apiURL });

useHead({
  htmlAttrs: { lang: "en" },
  title: "Twiage Solutions Inc.",
});

utils.mainEventBus.on("Authentication.User.Logout_after", async () => {
  navigateTo("/login");
});
</script>

<template>
  <div>
    <NuxtLayout>
      <NuxtPage></NuxtPage>
    </NuxtLayout>
  </div>
</template>
